"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _O7FALLU5cjs = require('../__chunks/O7FALLU5.cjs');
require('../__chunks/WU47XUXM.cjs');
require('../__chunks/OJZKTJL7.cjs');


var _6P52IAFYcjs = require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/popover/popover-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function PopoverProvider(props = {}) {
  const store = _O7FALLU5cjs.usePopoverStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _6P52IAFYcjs.PopoverContextProvider, { value: store, children: props.children });
}


exports.PopoverProvider = PopoverProvider;
